// extracted by mini-css-extract-plugin
module.exports = {"mxvxiam":"mxvxiam"};